module.exports = __webpack_public_path__ + "static/media/phone-volume-up.a251ab75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/phone-volume-up.svg
// module id = 1331
// module chunks = 0